import { FC } from 'react';
import { FooterStyled } from './style';
import { Props } from './types';

const Footer: FC<Props> = ({ show, children, ...restProps }) => show && <FooterStyled {...restProps}>{children}</FooterStyled>;

export default Footer;
